import React from "react";

import { ButtonType } from "../../types";
import { CardOpenChatBtn } from "./CardOpenChatBtn";
import { CardCallBtn } from "./CardCallBtn";
import { CardRedirectBtn } from "./CardRedirectBtn";
import { AppStoreDownloadBtn, GooglePlayDownloadBtn } from "./DownloadApp";

export const CustomButton = (props: ButtonType): JSX.Element => {
    const { buttonType } = props;

    // TODO: Apply validation for data passed to components here. Fail loudly.
    switch (buttonType) {
        case "card-open-chat":
            return (<CardOpenChatBtn {...props} />);
        case "card-call":
            return (<CardCallBtn {...props} />);
        case "download-app--app-store":
            return (<AppStoreDownloadBtn />);
        case "download-app--google-play":
            return (<GooglePlayDownloadBtn />);
        case "card-redirect--new-tab":
            return (<CardRedirectBtn {...props} openInNewTab={true} />);
        default:
            return (<CardRedirectBtn {...props} />)
    }
}